// set up the webpack output public path based on the origin of the main script
// https://webpack.js.org/configuration/output/#outputpublicpath
// this allows us to pull other chunks from wherever the main js file is hosted
// in dev this is localhost, in prod it is the s3 bucket at the branch/release path
const mainScriptSrc = (document.currentScript as any).src;
const lazyLoadDomain =
  mainScriptSrc.slice(0, mainScriptSrc.lastIndexOf('/')) + '/';
declare let __webpack_public_path__: string;
__webpack_public_path__ = lazyLoadDomain;
